const toastConfig = {
        position: "bottom-right",
        autoClose: 2800,
        hideProgressBar: true,
      };

export default toastConfig;